<template>
    <div class="mask" v-show="isShow" ref="mask" @contextmenu="contextmenu">
        <div class="inner">
            <div class="title">{{message.title}} <i @click.stop="close" class="iconfont iconguanbi"></i></div>
            <div class="body">
                <img :src="message.content" v-if="message.type == 1" />
                <video :src="message.content" v-if="message.type == 2" width="100%" height="100%" controls autoplay></video>
            </div>
        </div>
    </div>
</template>

<script>
export default {

    name: 'mr_toast',

    data(){
        return {
            isShow: false,
            message: {
                title: '',
                type: 1,     // 1 - 图片; 2 - 视频
                content: ''
            }
        }
    },

    methods: {

        close(){
            this.isShow = false
            if( this.closeHandler ) this.closeHandler()
        },

        contextmenu(e){
            e.preventDefault()
        }
    }
}
</script>

<style lang="scss" scoped>
.mask{
    width: 100vw; height: 100vh; background-color: rgba(0, 0, 0, 0.5); display: flex; justify-content: center; align-items: center; position: fixed; top: 0; left: 0; z-index: 9999;
    .inner{
        width: 60vw; height: 70vh; background-color: #fff; border-radius: 10px; padding: 10px 30px;
        .title{ 
            height: 45px; line-height: 40px; font-size: 18px; position: relative; border-bottom: 1px solid rgba(7, 44, 110, 0.2); text-align: center; margin-bottom: 10px;
            .iconfont{ position: absolute; right: 0; top: 0; font-size: 18px; transition: transform 1s; cursor: pointer; }
            .iconfont:hover{ transform: scale(1.2); }
        }
        .body{
            width: 100%; height: calc(100% - 60px); overflow: scroll; display: flex; justify-content: center; align-items: center; scrollbar-width: none; /* Firefox */
            .video{
                width: 100%; height: 100%;
            }
            &::-webkit-scrollbar {
                display: none; /* Chrome Safari */
            }
        }
    }
}
</style>